import React from "react";
import HeroTelealarmeISS from "../../Components/HeroTelealarmeISS/HeroTelealarmeISS";
import TelealarmeISSIntro from "../../Components/TelealarmeISSIntro/TelealarmeISSIntro";
import TelealarmeISSEquipment from "../../Components/TelealarmeISSEquipment/TelealarmeISSEquipment";
import TelealarmeISSCallFlow from "../../Components/TelealarmeISSCallFlow/TelealarmeISSCallFlow";
import TelealarmeISSIntegration from "../../Components/TelealarmeISSIntegration/TelealarmeISSIntegration";
import TelealarmeISSProofs from "../../Components/TelealarmeISSProofs/TelealarmeISSProofs";
import TelealarmeISSTechFAQ from "../../Components/TelealarmeISSTechFAQ/TelealarmeISSTechFAQ";
import TelealarmeISSQuote from "../../Components/TelealarmeISSQuote/TelealarmeISSQuote";

/**
 * Téléalarme ISS — Page complète / sections 01 à 08.
 * Seule la section 08 "Demande de devis" a été ajoutée après Technique & FAQ.
 * Les sept composants validés précédents restent inchangés.
 */
export default function TelealarmeISS() {
  return (
    <main>
      <HeroTelealarmeISS />
      <TelealarmeISSIntro />
      <TelealarmeISSEquipment />
      <TelealarmeISSCallFlow />
      <TelealarmeISSIntegration />
      <TelealarmeISSProofs />
      <TelealarmeISSTechFAQ />
      <TelealarmeISSQuote />
    </main>
  );
}
